import { get } from 'lodash'
import { email, emailOrPhoneRequired, required } from 'utils/validation'
import { ACTIVITY_CATEGORIES } from 'constants/enums'

export default function(values, props) {
  const isAssessorManagementEnabled = get(props, 'isAssessorManagementEnabled')

  const isAssessorDetailMandatory = get(props, 'isAssessorDetailMandatory')
  const errors = {
    activityCategory: {
      parent: {
        id: required(get(values, 'activityCategory.parent.id'))
      },
      id: required(get(values, 'activityCategory.id'))
    },
    goal: required(get(values, 'goal')),
    startDate: required(get(values, 'startDate')),
    endDate: required(get(values, 'endDate')),
    locationDetail: required(get(values, 'locationDetail')),
    note: required(get(values, 'note')),
    projectLocationType: {
      value: required(get(values, 'projectLocationType.value'))
    },

  }

  if (isAssessorDetailMandatory && !isAssessorManagementEnabled) {
    const emailOrPhoneCheck = emailOrPhoneRequired(get(values, 'assessorEmail'), get(values, 'assessorPhone'))

    errors.assessorName =  required(get(values, 'assessorName'))
    errors.assessorEmail = emailOrPhoneCheck || email(get(values, 'assessorEmail'))
    errors.assessorPhone = emailOrPhoneCheck

  } else if(isAssessorManagementEnabled){
    const isNoneOfTheseSubCategory = get(values, 'setupAssessorId') === 0

    errors.setupAssessorId = required(get(values, 'setupAssessorId'))

    if (isNoneOfTheseSubCategory) {
      errors.assessorTitle = required(get(values, 'assessorTitle'))
      errors.assessorName =  required(get(values, 'assessorName'))
      errors.assessorEmail = required(get(values, 'assessorEmail')) || email(get(values, 'assessorEmail'))
      errors.assessorPhone = required(get(values, 'assessorPhone'))
    }
  }

  if (get(values, 'activityCategory.id') === ACTIVITY_CATEGORIES.other.id) {
    errors.otherName = required(get(values, 'otherName'))
  }

  return errors
}
